<template>
  <div class="course-container">
    <router-view />
    <div class="course-create">
      <editor />
      <a role="button" class="create" @click="saveCourse">
        <div class="symbol">+</div>
        <div class="create-text">添加课程</div>
      </a>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import Editor from '@/components/course/Editor';
import { COURSE_TYPE_TRAINER, COURSE_TYPE_COACH, COURSE_TYPE_PRIVATE } from '@/constants/types';
import { ROUTE_CALENDAR, ROUTE_COURSE_BOOT_TRAINERS } from '@/router/names';
import { POST_COURSE } from '@/store/course/types';

const { mapState, mapActions } = createNamespacedHelpers('course');

export default {
    computed: {
        ...mapState([
            'draft',
            'created',
        ]),
        title() {
            if (this.draft.type === COURSE_TYPE_COACH) {
                return '自己训练';
            }
            if (this.draft.type === COURSE_TYPE_PRIVATE) {
                return '私人事件';
            }
            return '新增课程';
        },
    },
    created() {
        if (this.draft.type === COURSE_TYPE_TRAINER && !this.draft.trainer_id) {
            this.$router.push({
                name: ROUTE_COURSE_BOOT_TRAINERS,
            });
        }
    },
    mounted() {
        document.title = this.title;
    },
    methods: {
        ...mapActions({
            postCourse: POST_COURSE,
        }),
        async saveCourse() {
            const { date } = this.draft;
            await this.postCourse();
            this.$router.push({
                name: ROUTE_CALENDAR,
                query: {
                    date,
                },
            });
        },
    },
    components: {
        Editor,
    },
};
</script>


<style lang="scss" scoped>
.course-create {
  padding-bottom: 18.666666666vw;
}

.create {
  position: fixed;
  bottom: 0;
  width: 100vw;
  height: 13.333333333vw;
  display: flex;
  align-items: center;
  text-align: center;
  z-index: 100;

  .symbol {
    width: 20vw;
    flex: none;
    background-color: white;
    color: #448a13;
    font-size: 8.533333333vw;
    line-height: 1.5625;
  }

  .create-text {
    flex: auto;
    background-color: #448a13;
    color: white;
    font-size: 6.4vw;
    line-height: 13.333333333vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/course/Create.vue